import core, { App, GQL } from '@gin-betting/core';

import { ACTIVE_MARKET_STATUSES } from 'app-constants';

const { appServiceLocator } = core;

const apiClient = appServiceLocator.get('apiClient');

const fetchFeaturedCustomList = (
    slug: string
): Promise<void | App.TypedFetchResult<GQL.GetFeaturedCustomListQuery>> =>
    apiClient
        .makeRequest({
            method: 'getFeaturedCustomList',
            variables: {
                slug,
                limit: 20,
                offset: 0,
                marketStatuses: ACTIVE_MARKET_STATUSES,
                matchStatuses: [
                    GQL.SportEventStatus.LIVE,
                    GQL.SportEventStatus.NOT_STARTED,
                    GQL.SportEventStatus.SUSPENDED,
                ],
                isTopMarkets: true,
                marketLimit: 3,
            },
        })
        .catch(err => {
            console.error(err);
        });

export default fetchFeaturedCustomList;
